import angular from 'angular';

import * as tierActions from '../../../store/actions/member-tiers';
import * as userActions from '../../../store/actions/user';

import template from './change-member-tier.html';

import './change-member-tier.less';

const mapStateToScope = (state) => {
  return {
    tiers: state.tiers?.allMemberTiers,
    isLoadingLoyaltyStatistics: state.user.isLoadingLoyaltyStatistics,
    loyaltyStatistics: state.user.loyaltyStatistics,
  };
};

angular.module('myConsultApp').directive('changeMemberTier', () => {
  return {
    template,
    restrict: 'E',
    scope: {},
    controller: ($scope, $rootScope, $ngRedux, $http, ENV) => {
      $scope.tierOptions = null;
      $scope.selectedTier = null;
      $scope.confirmChangeTierDialogOptions = {
        heading: 'Warning',
        message: `Are you sure you want to change this member's tier?`,
        buttons: [
          {
            label: 'OK',
            href: '#',
            clickFn: () => {
              $scope.submitTierChange();
            },
          },
          {
            label: 'Cancel',
            href: '#',
            clickFn: () => {
              $scope.isConfirmingTierChange = false;
            },
          },
        ],
      };

      $scope.init = () => {
        $scope.unsubscribe = $ngRedux.connect(mapStateToScope, { ...tierActions, ...userActions })(
          $scope,
        );
        $scope.getAllMemberTiers($http, ENV).catch((error) => {
          console.warn(error);
        });
      };

      $scope.init();

      $scope.unwatch = $scope.$watchGroup(
        ['isLoadingLoyaltyStatistics', 'tiers'],
        ([isLoadingLoyaltyStatistics, tiers], oldValues, scope) => {
          if (!isLoadingLoyaltyStatistics && tiers?.length > 0) {
            $scope.tierOptions = tiers.filter(
              (tier) =>
                tier.minimum_points >
                scope.loyaltyStatistics?.current_earning_period?.earning_period_points,
            );
          }
        },
      );

      $scope.selectTier = (tier) => {
        $scope.selectedTier = tier;
      };

      $scope.confirmTierChange = () => {
        $scope.confirmChangeTierDialogOptions.message = `Are you sure you want to change this member's tier from ${$scope.loyaltyStatistics?.current_tier?.tier?.title} to ${$scope.selectedTier?.title}?`;
        $scope.isConfirmingTierChange = true;
      };

      $scope.submitTierChange = () => {
        $scope.errorMessage = null;
        $scope.isConfirmingTierChange = false;
        $scope.isSubmittingTierChange = true;
        $scope
          .changeMemberTier($http, ENV, $rootScope.userId, $scope.selectedTier?.id)
          .then(() => {
            $scope.isSubmittingTierChange = false;
            $rootScope.getData();
            $rootScope.closeComponent();
            $scope.$digest();
          })
          .catch((error) => {
            $scope.isSubmittingTierChange = false;
            $scope.errorMessage =
              error?.data?.['loyalty-statistics']?.error ||
              'We encountered a problem submitting this tier change request. Please try again.';
            $scope.$digest();
          });
      };

      $scope.$on('$destroy', () => {
        $scope.unsubscribe();
        $scope.unwatch();
      });
    },
  };
});
